import namespace from '@/store/namespace'
export default namespace('Autentication', {
  getters: [
    'GetListaMenus',
    'GetListaRepLegales',
    'GetOficinaId'

  ],
  actions: [
    'Login',
    'Cambiar_contrasenia',
    'Actualizar_correo',
    'ResetearClave',
    'ReactivarCuenta',
    'ObtenerListaMenus',
    'RepresentanteLegal',
    'VerificacionCorreoElectronico',
    'BitacoraCorreoElectronico',
    'BitacoraTotalCorreo',
    'ObtenerPersona',
    'ObtenerIdOficina'
  ],
  mutations: [
    'SetListaMenus',
    'SetRepLegal',
    'SetBitacoraTotalCorreo',
    'SetOficinaId'
  ]
})
